import { Tooltip, Badge } from 'antd';
import React, { useState } from 'react';

import IconAndName from './IconAndName';

const NavTooltip = (props) => {

  const { tooltipComponent,
    classesForParentDiv,
    name,
    src,
    onClick,
    notificationCount,
    isActivity = false
  } = props;

  const [open, setOpen] = useState(false);

  let hideTooltip = false;
  if (classesForParentDiv?.includes('selected')) {
    hideTooltip = true;
  }

  const handleClick = () => {
    setOpen(false);
    onClick?.();
  };

  return (
    <Tooltip
      color='none'
      placement='rightTop'
      autoAdjustOverflow
      open={!hideTooltip && tooltipComponent ? open : false}
      onOpenChange={(v) => setOpen(v)}
      title={!hideTooltip && tooltipComponent &&
        <div className='nav-tooltip' style={{ ...props.style, color: 'black', overflow: 'hidden', display: 'flex', flexDirection: 'column', ...(isActivity ? { maxWidth: 'unset' } : {}) }}>
          {tooltipComponent}
        </div>
      }>
      <div style={{ position: 'relative' }}>
        <IconAndName
          name={name}
          phase='sideNav'
          src={`${src}.svg`}
          height={20}
          width={48}
          classesForParentDiv={classesForParentDiv}
          class={"navLinks"}
          iconFuction={handleClick}
          onPress={handleClick}
        />
       {notificationCount > 0 && <Badge
          className='tooltip-notification-bubble'
          count={notificationCount}
          style={{
            boxShadow: 'none',
            padding: 0
          }}
        />}
      </div>
    </Tooltip>
  );
};

export default NavTooltip;
